import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle, faCheckCircle,  faExclamationCircle, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons"

export default function InfoBox(props) {
  let type = props.type? props.type : "info";
  let content_type = props.contentType ? props.contentType: "string";
  let content_title = props.contentTitle ? props.contentTitle : "";
  let content = props.content ? props.content : null;
  let icon = <FontAwesomeIcon icon={faInfoCircle} className="info-box__icon" />

  switch(type) {
    case "info":
      icon = <FontAwesomeIcon icon={faInfoCircle} className="info-box__icon" />
      break;
    case "success":
      icon = <FontAwesomeIcon icon={faCheckCircle} className="info-box__icon" />
      break;
    case "alert":
      icon = <FontAwesomeIcon icon={faExclamationCircle} className="info-box__icon" />
      break;
    default:
      icon = <FontAwesomeIcon icon={faInfoCircle} className="info-box__icon" />
  }

  let classProps = ['info-box'];
  if (type) {classProps.push('info-box--'+type)}
  if (props.fullWidth) {classProps.push('info-box--full-width')}
  if (props.width100) {classProps.push('info-box--width100')}
  if (props.className) {classProps.push(props.className)}

  let attrProps = {};
  if (props.style) {
    attrProps.style = props.style;
  }

  return (
    <div {...attrProps} className={classProps.join(' ')} style={props.style}>
      {icon}
      {props.children}
      {content_type == "string" && content && <>{content}</>}
      {content_type == "array" && content && <><b>{content_title}</b>{content.map(i => <p>{i}</p>)}</>}
    </div>
  )
};